import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import TableCell, { TableCellProps } from '@material-ui/core/TableCell';

const useStyles = makeStyles<Theme>(() => {
  return {
    typographyContent: {
      fontSize: '0.70rem',
      height: '23px',
      fontWeight: 900,
      color: '#4A4A4A',

      lineHeight: '23px'
    },
    iconSize: {
      width: '10px'
    },
    contentContainer: {
      display: 'inline-flex',
      marginRight: '0'
    },
    iconContainer: {
      height: '10px',
      width: '5px'
    }
  };
});

interface ClassSelectTableHeadCellProps extends TableCellProps {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  SortIcon?: React.ReactNode;
  typographyProps?: Omit<TypographyProps, 'children'>;
  innerContainerProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  iconContainerProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >;
}
const ClassSelectTableHeadCell: React.FC<ClassSelectTableHeadCellProps> = ({
  children,
  onClick,
  SortIcon,
  innerContainerProps = {},
  iconContainerProps = {},
  ...rest
}) => {
  const classes = useStyles();
  return (
    <TableCell role="columnheader" {...rest}>
      <div onClick={onClick} className={classes.contentContainer} {...innerContainerProps}>
        {typeof children === 'string' ? (
          <Typography component={'span'} className={classes.typographyContent}>
            {children}
          </Typography>
        ) : (
          children
        )}
        {SortIcon && (
          <span className={classes.iconContainer} {...iconContainerProps}>
            {SortIcon}
          </span>
        )}
      </div>
    </TableCell>
  );
};

export default ClassSelectTableHeadCell;
